import Vue from 'vue';

const state = Vue.observable({
  isLoading: true,
  budgetTableScrollPosition: 0,
  scrollPosition: [],
  allocationUnitsTableScrollPosition: 0,
  updateVisibleFields: (type, fields) => {
    state.visibleFieldsOrders = fields;
    localStorage.setItem('visibleFields' + type, JSON.stringify(fields));
  },
  loadVisibleFields(type, fields) {
    var localStorageFields = JSON.parse(localStorage.getItem('visibleFields' + type)) || [];
    for (const field of localStorageFields) {
      const refField = fields.find(x => x.key == field.key);
      if (refField) {
        refField.visible = field.visible == true || field.visible == 'true';
      } else {
        field.visible = true;
      }
      //fields.find(x => x.key == field.key).visible = field.visible == true || field.visible == 'true';
    }
  },
  showNav: true || this.$route.query,
  showNavForced: false,
  invoiceTypes: [],
  currentCnR: {},
  currentCnRVE: null,
  currentCnRIsDirty: false,
  cnrSearchText: '',
  cnrSearchTextProject: '',
  cnrSearchTextVe: '',
  cnrSearchTextVeList: ''
});

export default state;
